module.exports = __webpack_public_path__ + "img/head-r.3004e68f.png";